module.exports = __webpack_public_path__ + "static/media/carta_33.124f0922.jpg";